import { EditableUser } from "../types";
import { scaffoldEdit } from "common/scaffolding/reducers/scaffoldEdit";

export enum TypeKeys {
    FETCH_BEGIN = "USER/FETCH_EDITABLE_BEGIN",
    FETCH_SUCCESS = "USER/FETCH_EDITABLE_SUCCESS",
    FETCH_FAILURE = "USER/FETCH_EDITABLE_FAILURE",

    SAVE_BEGIN = "USER/SAVE_EDITABLE_BEGIN",
    SAVE_SUCCESS = "USER/SAVE_EDITABLE_SUCCESS",
    SAVE_FAILURE = "USER/SAVE_EDITABLE_FAILURE",
}

const edit = scaffoldEdit<EditableUser, EditableUser, typeof TypeKeys>(TypeKeys);
const { createAction, reducer } = edit;

export type State = ReturnType<typeof edit.reducer>;
export { createAction, reducer };

export type SavedAction = ReturnType<typeof createAction.saved>;
